import { Route, Routes } from "react-router-dom";

import MakesPage from "./pages/MakesPage";
import ModelsPage from "./pages/ModelsPage";

function App() {
  return (
    <main>
      <Routes>
        <Route path="/" element={<MakesPage />} />
        <Route path="/models/:make" element={<ModelsPage />} />
      </Routes>
      <div className="center small">v22.10.15 b8</div>
    </main>
  );
}

export default App;
